/**
 * Checks if current browser environment is Android.
 */
export function isAndroidDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent || '');
}

/**
 * Checks if current browser environment is iOS (iPhone, iPad, iPod).
 */
export function isIOSDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || (typeof window !== 'undefined' && (window as any).opera) || '';
  const isIPadOS = (navigator.maxTouchPoints || 0) > 1 && /Macintosh/.test(ua);
  return /iPad|iPhone|iPod/i.test(ua) || isIPadOS;
}

/**
 * Checks if current browser environment is a mobile phone/tablet (Android or iOS).
 */
export function isMobileDevice(): boolean {
  return isAndroidDevice() || isIOSDevice();
}

/**
 * Checks if current device is a Samsung Galaxy / Samsung browser.
 */
export function isSamsungDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /Samsung/i.test(ua) || (/Android/i.test(ua) && /SM-|SAMSUNG|SCH-|SGH-|SPH-/i.test(ua));
}
